import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema()
export class LeadAccountMergeData {

    @MergeField()
    type: string;

    @MergeField()
    name: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;
}

export const LeadAccountMergeSchema = getSchema(LeadAccountMergeData);